<template>
  <div class="-image">
    <div class="-thumbnail-wrapper">
      <div class="-thumbnail" :class="classObj" @click="previewAsset">
        <wt-asset-overlay
          :dateFull="publicationDateFull"
          :date="publicationDate"
          :is-asset-restricted="isAssetRestricted"
          :restrictions-text="assetRestrictions"
        >
          <template v-if="isWebpage">
            <span
              slot="append-right"
              v-tooltip="icoTooltip"
              class="wticon wticon-globe"
            ></span>
          </template>
        </wt-asset-overlay>
        <a href="#" v-if="!imageError">
          <div v-if="loading" class="-placeholder">
            <span class="wticon wticon-picture-sun"></span>
          </div>
          <img
            :src="mixinSrc(src)"
            @error="onImageError"
            @load="loading = false"
          />
        </a>
        <div v-else class="-placeholder -error">
          <span class="wticon wticon-picture-sun"></span>
        </div>
        <slot name="checkmark"></slot>
      </div>
      <footer :title="footerTitle">
        <span class="-title">{{ footerTitle }}</span>
      </footer>
    </div>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetOverlay from 'components/assets/mixins/AssetOverlay.vue';
import Vue from 'vue';

export default Vue.extend({
  mixins: [AssetMixins],
  components: { 'wt-asset-overlay': AssetOverlay },

  computed: {
    icoTooltip() {
      if (!this.isWebpage) {
        return false;
      }
      return {
        animation: false,
        trigger: 'hover focus',
        container: '.wt2-asset-gallery .-scroll-container',
        placement: 'bottom auto',
        viewport: {
          selector: '.wt2-asset-gallery .-scroll-container',
          padding: 2,
        },
        delay: { show: 250, hide: 0 },
        wrapperClass: 'tooltip-lightbox-wrapper',
        title: 'Web Page',
      };
    },
    src: function () {
      return (
        this.asset.thumbnail ||
        this.asset.metadata.thumbnail256x144Url ||
        this.asset.metadata.thumbnail160x90Url ||
        this.asset.metadata.urlCdn ||
        null
      );
    },
    icons() {
      return [
        { iconClass: 'wticon-picture2', location: 'left' },
        { iconClass: 'wticon-licensed-media2', location: 'right' },
      ];
    },
    isWebpage() {
      return app.assetType.isWEBPAGE(this.asset);
    },
    classObj() {
      return {
        '-webpage': this.isWebpage,
      };
    },
    footerTitle() {
      return _.isEmpty((this.asset.metadata.title || '').trim())
        ? this.asset.metadata.caption
        : this.asset.metadata.title;
    },
  },

  methods: {},
});
</script>
